import { _UserData } from 'base/src/infra/storage/localStorage';
import { CarteiraOAuthService } from './carteiraOAuthService';
import { CarteiraOAuthResponse } from '../../types/auth/carteiraOAuthResponse';

const CARTEIRA_TOKEN_KEY = 'CarteiraToken';
const CARTEIRA_TOKEN_EXPIRY_KEY = 'CarteiraTokenExpiry';
const EXPIRY_BUFFER_MS = 60 * 1000;

class CarteiraTokenManager {
    private static instance: CarteiraTokenManager = new CarteiraTokenManager();
    private refreshPromise: Promise<string | null> | null = null;
    private oauthService: CarteiraOAuthService = new CarteiraOAuthService();

    private constructor() { }

    public static get Instance(): CarteiraTokenManager {
        return this.instance;
    }

    async GetCarteiraToken(): Promise<string | null> {
        const token = _UserData.GetOtherData<string>(CARTEIRA_TOKEN_KEY);
        const expiryStr = _UserData.GetOtherData<string>(CARTEIRA_TOKEN_EXPIRY_KEY);

        if (token && token !== '' && expiryStr) {
            const expiry = Number(expiryStr);
            if (Date.now() < expiry - EXPIRY_BUFFER_MS) {
                return `Bearer ${token}`;
            }
        }

        return this.RefreshToken();
    }

    async RefreshToken(): Promise<string | null> {
        if (this.refreshPromise) {
            return this.refreshPromise;
        }

        this.refreshPromise = this.doRefresh();

        try {
            return await this.refreshPromise;
        } finally {
            this.refreshPromise = null;
        }
    }

    private async doRefresh(): Promise<string | null> {
        const response = await this.oauthService.GetToken();

        if (response instanceof Error) {
            // eslint-disable-next-line no-console
            console.error('Falha ao obter token OAuth2 da Carteira:', response.message);
            return null;
        }

        const oauthResponse = response as CarteiraOAuthResponse;

        // Handle both OAuth2 standard (number of seconds) and custom format (ISO date string)
        let expiryTime: number;
        if (typeof oauthResponse.expires_in === 'number') {
            // Standard OAuth2: expires_in is seconds until expiration
            expiryTime = Date.now() + (oauthResponse.expires_in * 1000);
        } else {
            // Custom format: expires_in is an ISO date string
            expiryTime = new Date(oauthResponse.expires_in).getTime();
        }

        _UserData.SetOtherData(CARTEIRA_TOKEN_KEY, oauthResponse.access_token);
        _UserData.SetOtherData(CARTEIRA_TOKEN_EXPIRY_KEY, expiryTime.toString());

        return `Bearer ${oauthResponse.access_token}`;
    }
}

export const carteiraTokenManager = CarteiraTokenManager.Instance;
